var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 42.2q-1.8 0-3.175-1.35Q5.7 39.5 5.7 37.6v-9.4h4.55v9.4H37.7v-9.4h4.55v9.4q0 1.9-1.4 3.25T37.7 42.2ZM21.7 31.25v-17.8l-5.65 5.7-3.25-3.3L24 4.65l11.25 11.2-3.35 3.3-5.65-5.7v17.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/upload_FILL1_wght700_GRAD200_opsz48.ee8714f5839b23b765ec81b2a4342af2.svg";
export { ForwardRef as ReactComponent };